<div
  class="select-building d-flex flex-column justify-content-center align-items-center pr-3 mb-5"
>
  <div
    class="text-container d-flex flex-column justify-content-center align-items-center"
  >
    <div class="icon-container" [ngSwitch]="data">
      <img
        *ngSwitchCase="'PLEASE_SELECT_A_BUILDING' | translate"
        src="assets/svg/ico-floor.svg"
        class="building-icon"
      />
      <img
        *ngSwitchCase="'PLEASE_SELECT_A_UNIT_OR_ACCESSPOINT' | translate"
        src="assets/svg/ico-default-home.svg"
        class="building-icon"
      />
      <img
        *ngSwitchCase="'PLEASE_SELECT_A_UNIT' | translate"
        src="assets/svg/ico-default-home.svg"
        class="building-icon"
      />
    </div>
    <div class="text-center mt-3">
      <p>{{ data }}</p>
    </div>
    <button
      *ngIf="retry"
      (click)="retryAction()"
      class="refresh pointer-cursor d-flex justify-content-center w-100"
    >
      <img src="assets/svg/ico-refresh.svg" class="icon mr-2" />
      {{ retryText }}
    </button>
  </div>
</div>
